import * as React from "react"
import CryptoListItem from "./CryptoListItem"



export default function CryptoFunctionsList({ items }) {
    return (
        <>
            <div className="crypto-list-grid-3-container">
                {items.map((data, index) => {
                    return <CryptoListItem key={index} imageUrl={data.url} text={data.text} />
                })}
            </div>
        </>
    )
}